import React from "react";

import "../assets/styles/components/HeroBanner.css";

const HeroBanner = () => {
  return (
    <section className="hero-section text-white text-center d-flex align-items-center justify-content-center">
    <div className="container">
    <h1>Location de bureaux à Villiers-Le-Bel</h1>
    <h2>Espaces de travail partagé - coworking de qualité, proche de Sarcelles, dans un quartier calme et fréquenté.</h2>
      <p>
        Découvrez ACG-VO, votre partenaire pour la location de bureaux,
        salles de réunion et espaces partagés au cœur du Val d'Oise.
      </p>

      <a href="#services" className="btn btn-lg btn-success m-md-4 m-sm-1">
        Découvrez nos services
      </a>
      <a href="#contact" className="btn btn-lg btn-success m-md-4 m-sm-1">
      Programmer une visite
      </a>
    </div>
  </section>
  );
};

export default HeroBanner;
